import React from 'react';
import { Box, Checkbox, Typography, Button } from '@mui/material';

import FileDownloadIcon from '@mui/icons-material/FileDownload';
import MovieFilterIcon from '@mui/icons-material/MovieFilter';
import EditNoteIcon from '@mui/icons-material/EditNote';
import CheckBoxIcon from '@mui/icons-material/CheckBox';
import PlaylistPlayIcon from '@mui/icons-material/PlaylistPlay';

const GameTagControlSection = ({ clipCount, isSelectAll, onAll, onHudl, onRender, onEdits, t }) => {
    return (
        <Box
            sx={{
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'space-between',
                width: '100%',
                padding: '16px 20px',
                backgroundColor: '#ffffff',
                borderRadius: '12px',
                marginTop: '16px',
                marginBottom: '8px',
                boxShadow: '0 1px 3px rgba(0,0,0,0.08)'
            }}
        >
            <Box sx={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
                <PlaylistPlayIcon sx={{ color: '#6366f1', fontSize: 24 }} />
                <Typography sx={{ fontSize: '15px', fontWeight: 600, color: '#1f2937' }}>
                    {clipCount} {t('Clips')}
                </Typography>
            </Box>

            <Box sx={{ display: 'flex', alignItems: 'center', gap: '12px' }}>
                <Box
                    sx={{
                        display: 'flex',
                        alignItems: 'center',
                        cursor: 'pointer',
                        padding: '6px 12px',
                        borderRadius: '8px',
                        backgroundColor: isSelectAll ? '#e0e7ff' : '#f3f4f6',
                        transition: 'all 0.2s ease',
                        '&:hover': { backgroundColor: '#e0e7ff' }
                    }}
                    onClick={(e) => onAll({ target: { checked: !isSelectAll } })}
                >
                    <Checkbox
                        checked={isSelectAll}
                        size="small"
                        sx={{
                            padding: 0,
                            marginRight: '6px',
                            color: '#6366f1',
                            '&.Mui-checked': { color: '#6366f1' }
                        }}
                    />
                    <Typography sx={{ fontSize: '13px', fontWeight: 500, color: '#374151' }}>
                        {t('Select All')}
                    </Typography>
                </Box>

                <Button
                    variant="outlined"
                    startIcon={<FileDownloadIcon />}
                    onClick={onHudl}
                    sx={{
                        textTransform: 'none',
                        borderColor: '#e5e7eb',
                        color: '#374151',
                        fontWeight: 500,
                        fontSize: '13px',
                        borderRadius: '8px',
                        padding: '6px 16px',
                        '&:hover': {
                            borderColor: '#6366f1',
                            backgroundColor: '#f5f3ff',
                            color: '#6366f1'
                        }
                    }}
                >
                    {t('Sportcode')}
                </Button>

                <Button
                    variant="outlined"
                    startIcon={<MovieFilterIcon />}
                    onClick={onRender}
                    sx={{
                        textTransform: 'none',
                        borderColor: '#e5e7eb',
                        color: '#374151',
                        fontWeight: 500,
                        fontSize: '13px',
                        borderRadius: '8px',
                        padding: '6px 16px',
                        '&:hover': {
                            borderColor: '#22c55e',
                            backgroundColor: '#f0fdf4',
                            color: '#22c55e'
                        }
                    }}
                >
                    {t('Render')}
                </Button>

                <Button
                    variant="outlined"
                    startIcon={<EditNoteIcon />}
                    onClick={onEdits}
                    sx={{
                        textTransform: 'none',
                        borderColor: '#e5e7eb',
                        color: '#374151',
                        fontWeight: 500,
                        fontSize: '13px',
                        borderRadius: '8px',
                        padding: '6px 16px',
                        '&:hover': {
                            borderColor: '#f59e0b',
                            backgroundColor: '#fffbeb',
                            color: '#f59e0b'
                        }
                    }}
                >
                    {t('My Edits')}
                </Button>
            </Box>
        </Box>
    );
};

export default GameTagControlSection;
